import React from "react";
import { Bank } from "../Components";

export const Cod = () => {
  return <Bank />;
};
